module.exports = __webpack_public_path__ + "static/img/200269.35a6ccd4.png";